import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=f01f7364&scoped=true&"
import script from "./singleCustomer.vue?vue&type=script&lang=js&"
export * from "./singleCustomer.vue?vue&type=script&lang=js&"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=f01f7364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01f7364",
  null
  
)

export default component.exports